import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { fetchTypeProducts } from '../../services/services';
import { fallbackProductTypes } from './homePage.data';

const useHomeProductTypes = () => {
  const dispatch = useAppDispatch();
  const { unqTypes } = useAppSelector((state) => state.productsType);

  useEffect(() => {
    if (!unqTypes?.length) {
      dispatch(fetchTypeProducts());
    }
  }, [dispatch, unqTypes?.length]);

  return unqTypes?.length ? unqTypes : fallbackProductTypes;
};

export default useHomeProductTypes;
